import * as Sentry from "@sentry/vue";
window.Sentry = Sentry;